'use strict';

module.exports = require('./node-progress');
//# sourceMappingURL=index.js.map